const CHAPTER_DATA = [
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/start-corona-gekuerzt.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/start-corona-gekuerzt.mp4?v=2',
        videoYaw: 120,
        title: 'Entdecken Sie Sylt in 360 Grad',
        subtitle: 'Virtuelle Reise',
        locatorSrc: 'images/maps/start3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/hindenburgdamm.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/hindenburgdamm.mp4?v=2',
        videoYaw: 0,
        title: 'So kommen Sie auf die Insel',
        subtitle: 'Anreise nach Sylt',
        locatorSrc: 'images/maps/anreise3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/rotes-kliff.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/rotes-kliff.mp4?v=2',
        videoYaw: 120,
        title: 'Am Wahrzeichen Sylts',
        subtitle: 'Die rote Steilküste',
        locatorSrc: 'images/maps/kliff3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/ellenbogen.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/ellenbogen.mp4?v=2',
        videoYaw: 180,
        title: 'Am nördlichsten Punkt Deutschlands',
        subtitle: 'Sylts Ellenbogen',
        locatorSrc: 'images/maps/ellenbogen3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/wattwanderung.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/wattwanderung.mp4?v=2',
        videoYaw: 120,
        title: 'Warum Sylt im Corona-Sommer perfekt ist',
        subtitle: 'Unterwegs mit dem Wattführer',
        locatorSrc: 'images/maps/watt3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/friedrichstrasse.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/friedrichstrasse.mp4?v=2',
        videoYaw: 120,
        title: 'Shoppen auf der Einkaufsmeile',
        subtitle: 'Shopping auf Abstand',
        locatorSrc: 'images/maps/friedrichstrasse3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/kuestenschutz.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/kuestenschutz.mp4?v=2',
        videoYaw: 120,
        title: 'Der Kampf gegen Erosion',
        subtitle: 'Die Insel in Gefahr',
        locatorSrc: 'images/maps/kustenschutz3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/radfahren.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/radfahren.mp4?v=2',
        videoYaw: 120,
        title: 'Mit dem Rad über die Insel',
        subtitle: 'Fahrradtouren im Wind',
        locatorSrc: 'images/maps/radweg3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/friesenhaeuser-braderup.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/friesenhaeuser-braderup.mp4?v=2',
        videoYaw: 120,
        title: 'Das Wattenmeer vor der Haustür',
        subtitle: 'Friesenhäuser von Braderup',
        locatorSrc: 'images/maps/friesenhauser3.png',
    },
    {
        video: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/whiskeymeile.mp4?v=2',
        videoMobile: (ARTICLE_CONFIG.baseUrl)+'/data/video/sylt-mobile/whiskeymeile.mp4?v=2',
        videoYaw: 120,
        title: 'Dörfliches Ambiente trifft auf Luxus',
        subtitle: 'Hotspot Strönwai',
        locatorSrc: 'images/maps/whiskeymeile3.png',
    }
];


module.exports = CHAPTER_DATA;